import {
  Correspondent,
  CorrespondentInfo,
  CorrespondentItem,
  InstrumentItem,
  InstrumentType,
} from "../../../types";

import _ from "lodash";

export interface SliceValue {
  slice: string;
  value: string;
}

export function getChange(
  values: SliceValue[]
): { change: string; changePercentage: string } {
  const sod = values.find((val) => val.slice === "1")?.value;
  const latest = _.last(values)?.value;
  if (sod && latest != "") {
    const change = Number(latest) - Number(sod);
    const changePercentage = (change / Number(sod)) * 100;
    return {
      change: String(change),
      changePercentage: String(changePercentage),
    };
  } else {
    return {
      change: "",
      changePercentage: "",
    };
  }
}

export function getSliceValues(values: any): SliceValue[] {
  const valueArray: SliceValue[] = Object.entries(values).map(
    ([slice, value]) => {
      return {
        slice: slice,
        value: value as string,
      };
    }
  );
  valueArray.sort((a, b) => a.slice.localeCompare(b.slice));
  return valueArray;
}

export function getInstrumentValue(values: SliceValue[], sliceId: string) {
  if (sliceId === "latest") {
    return _.last(values)?.value as string;
  } else {
    const slice = values.find((val) => val.slice === sliceId)?.value as string;
    return slice ? slice : "";
  }
}

export function getInstrument(
  instrument: InstrumentItem,
  sliceId: string,
  date: string
): InstrumentType[] {
  return Object.entries(instrument).map(([name, instrumentObj]) => {
    const sliceValues: SliceValue[] = getSliceValues(instrumentObj.values);
    const changeObj = getChange(sliceValues);

    return {
      reportType: name,
      date: date,
      slice: sliceId,
      value: getInstrumentValue(sliceValues, sliceId),
      change: changeObj.change,
      changePercentage: changeObj.changePercentage,
      range: {
        high: instrumentObj.high,
        low: instrumentObj.low,
      },
    };
  });
}

export function mapCorrespondentValues(
  values: CorrespondentItem
): CorrespondentInfo[] {
  const correspondentInfoArray: CorrespondentInfo[] = [];
  Object.entries(values).map(([correspondentCode, value]) => {
    value.executionDataList.map((info: CorrespondentInfo) => {
      correspondentInfoArray.push({
        correspondentCode: info.correspondentCode,
        side: info.side,
        symbol: info.symbol,
        qty: info.qty,
      });
    });
  });

  return correspondentInfoArray;
}
